import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const BlogWrapper = styled.div`
  padding: 6rem 2rem;
  background: ${props => props.theme.colors.background};
  min-height: 100vh;
`;

export const BlogHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const BlogTitle = styled.h1`
  color: ${props => props.theme.colors.darkGreen};
  font-size: ${props => props.theme.fontSizes.huge};
  margin-bottom: 1.5rem;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background: ${props => props.theme.colors.brown};
    border-radius: 2px;
  }
`;

export const BlogSubtitle = styled.p`
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.fontSizes.large};
  opacity: 0.8;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const SearchSection = styled.div`
  max-width: 800px;
  margin: 0 auto 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  
  svg {
    position: absolute;
    right: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${props => props.theme.colors.gray};
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 1rem 3.5rem 1rem 1.5rem;
  border-radius: 50px;
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-size: 1rem;
  box-shadow: ${props => props.theme.shadows.small};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.darkGreen};
    box-shadow: ${props => props.theme.shadows.medium};
  }
`;

export const CategoryFilter = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const CategoryButton = styled.button`
  padding: 0.6rem 1.5rem;
  border-radius: 25px;
  border: 1px solid ${props => props.active ? props.theme.colors.darkGreen : props.theme.colors.border};
  background: ${props => props.active ? props.theme.colors.darkGreen : 'transparent'};
  color: ${props => props.active ? '#fff' : props.theme.colors.text};
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;

  &:hover {
    border-color: ${props => props.theme.colors.darkGreen};
    color: ${props => props.active ? '#fff' : props.theme.colors.darkGreen};
  }
`;

export const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const BlogCard = styled.article`
  background: ${props => props.theme.isDarkMode ? '#2a2a2a' : '#fff'};
  border-radius: 20px;
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-10px);
    box-shadow: ${props => props.theme.shadows.large};
  }
`;

export const BlogImage = styled.div`
  width: 100%;
  height: 220px;
  background-image: url(${props => props.image}), url(${props => props.fallbackImage});
  background-size: cover;
  background-position: center;
  position: relative;
  background-color: ${props => props.theme.colors.lightGray};
`;

export const BlogContent = styled.div`
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const BlogDate = styled.span`
  color: ${props => props.theme.colors.brown};
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  display: block;
`;

export const BlogCardTitle = styled.h2`
  color: ${props => props.theme.colors.darkGreen};
  font-size: 1.4rem;
  margin-bottom: 1rem;
  line-height: 1.4;
`;

export const BlogExcerpt = styled.p`
  color: ${props => props.theme.colors.text};
  opacity: 0.8;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex-grow: 1;
`;

export const ReadMore = styled.div`
  color: ${props => props.theme.colors.brown};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: gap 0.3s ease;

  svg {
    font-size: 1.2rem;
  }

  &:hover {
    gap: 0.8rem;
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 4rem;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.gray};
`;
